import PropTypes from 'prop-types';

export default {
  Cognito: {
    User: PropTypes.shape({
      attributes: PropTypes.shape({
        username: PropTypes.string,
        sub: PropTypes.string,
        email: PropTypes.string,
      }),
    }),
  },
};
